<template>
  <div style="width: 100%;font-size: 16px;">
    <!-- <div class="page-info">当前页面</div> -->
    <div class="exam"
         v-if="examInfo">
      <div class="exam-name">
        <div class="exam-title">{{examInfo.title}}<span class="exam-score"> (满分 {{examInfo.totalScore}}， 及格 {{examInfo.passScore}})</span></div>
        <div class="exam-time">剩余时间 {{Math.floor(this.allTime/60)}}分{{this.allTime%60}}秒</div>
      </div>
      <div class="test"
           v-if="questionIndex>-1 && paperQuestionList.length">
        <div v-if="(questionIndex-1)>0 && paperQuestionList[questionIndex-1].contentType===0">{{paperQuestionList[questionIndex-1].descript}}</div>
        <div class="question-body">
          <div class="question">{{paperQuestionList[questionIndex].idx}}、{{paperQuestionList[questionIndex].subject}}</div>
          <!-- 单选 -->
          <div v-if="paperQuestionList[questionIndex].subjectType === 1"
               class="option">
            <el-radio-group v-model="answer">
              <ul>
                <li v-for="(item, index) in paperQuestionList[questionIndex].optionVos"
                    :key="index">
                  <el-radio :label="item.option"
                            class="option-li">{{item.option}}、{{item.context}}</el-radio>
                </li>
              </ul>
            </el-radio-group>
          </div>
          <!-- 多选 -->
          <div v-else-if="paperQuestionList[questionIndex].subjectType === 2"
               class="option">
            <el-checkbox-group v-model="answer">
              <ul>
                <li v-for="(item, index) in paperQuestionList[questionIndex].optionVos"
                    :key="index">
                  <el-checkbox :label="item.option"
                               class="option-li">{{item.option}}、{{item.context}}</el-checkbox>
                </li>
              </ul>
            </el-checkbox-group>
          </div>
          <!-- 问答 -->
          <div v-else-if="paperQuestionList[questionIndex].subjectType === 3"
               class="option">
            <textarea maxlength="500"
                      v-model="answer"
                      class="answer-content"
                      rows="4"
                      placeholder="请输入评论内容...(最长500字)" />
          </div>
          <!-- 上传 -->
          <div v-else-if="paperQuestionList[questionIndex].subjectType === 4"
               class="option">
            <div class="test-file"
                 v-if="paperQuestionList[questionIndex].optionVos && paperQuestionList[questionIndex].optionVos[0].sysOssAliEntity"
                 @click="download(paperQuestionList[questionIndex].optionVos[0].sysOssAliEntity)">
              题目文件：{{paperQuestionList[questionIndex].optionVos[0].sysOssAliEntity.fileName}}
            </div>
            <textarea maxlength="500"
                      v-model="answer"
                      class="answer-content"
                      rows="4"
                      placeholder="请输入评论内容...(最长500字)" />
            <!-- 上传附件 -->
            <el-upload :action="actionUrl"
                       class="upload-demo"
                       :data="{ fileSuffixType: 'allType' }"
                       :accept="'.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.doc,.docx,.csv,.txt,.pdf,.zip,.rar,.ppt,.pptx'"
                       :auto-upload="true"
                       :headers="headerMsg"
                       :limit="1"
                       :before-remove="removeFile"
                       :on-success="successFile"
                       :on-error="errorFile"
                       ref="upLoadFile"
                       :before-upload="beforeUpload">
              <!-- <div tabindex="0" class="el-upload el-upload--picture-card">
                  <i class="el-icon-plus"></i>
                </div> -->
              <el-button size="small"
                         type="primary">点击上传</el-button>
              <div slot="tip"
                   class="el-upload__tip">上传文件不超过100MB</div>
            </el-upload>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div class="operation">
        <button :class="'button shop-cart-but'+(butLoading?' but-loading':'')+ (isBan?' forbidden':'')"
                @click.stop="last()">
          <!-- <i class="el-icon-loading" v-show="butLoading"></i> -->
          上一题
        </button>
        <button :class="'button shop-cart-but'+(butLoading?' but-loading':'')+ (isBan?' forbidden':'')"
                @click.stop="next()">
          <!-- <i class="el-icon-loading" v-show="butLoading"></i> -->
          下一题
        </button>
        <button :class="'button'+(butLoading?' but-loading':'') + (isBan?' forbidden':'')"
                @click.stop="handExamHandle()">
          <!-- <i class="el-icon-loading" v-show="butLoading"></i> -->
          交卷
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  name: 'startExam', // 开始考试
  data () {
    return {
      examInfo: null,
      questionIndex: -1,
      headerIndex: -1,
      butLoading: false,
      paperQuestionList: [],
      isBan: false,
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      headerMsg: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      answer: '',
      fileList: [], // 附件列表
      time: null,
      beginTime: null,
      allTime: 0
    }
  },
  computed: {
    examId () {
      return this.$route.query.id
    },
    paperUserId () {
      return this.$route.query.paperUserId
    },
    token () {
      return getAccessToken()
    }
  },
  created () {
    if (this.examId) {
      this.getInfo()
    }
  },
  watch: {
    examId (val) {
      this.examInfo = null
      this.questionIndex = -1
      this.headerIndex = -1
      this.paperQuestionList = []
      this.answer = ''
      this.fileList = []
      this.beginTime = null
      this.time = null
      this.allTime = 0
      clearInterval(this.time)
      // this.beginTime = ''
      if (val && this.token) {
        this.getInfo()
      }
    }
  },
  methods: {
    formatTime () {
      let start = new Date()
      let month = start.getMonth() + 1
      let hours = start.getHours()
      let min = start.getMinutes()
      let sec = start.getSeconds()
      return start.getFullYear() + '-' + (month >= 10 ? month : ('0' + month)) + '-' + (start.getDate() >= 10 ? start.getDate() : ('0' + start.getDate())) + ' ' + (hours >= 10 ? hours : ('0' + hours)) + ':' + (min >= 10 ? min : ('0' + min)) + ':' + (sec >= 10 ? sec : ('0' + sec))
    },
    getInfo () {
      this.butLoading = true
      this.$request.get(`/front/train/trainEmPaper/findFormalExamSubject/${this.examId}`)
        .then(data => {
          this.examInfo = data
          this.beginTime = new Date()
          let index = -1
          let paperQuestionList = data.paperQuestionVos || []
          paperQuestionList.forEach((item, idx) => {
            if (item.contentType === 1) {
              item.idx = idx - index
            } else {
              index = idx
            }
          })
          this.paperQuestionList = paperQuestionList
          this.allTime = this.examInfo.maxMinute * 60
          let _this = this
          this.time = setInterval(() => {
            _this.updateTime()
          }, 1000)
          this.getAnswer(paperQuestionList.findIndex(item => {
            return item.contentType === 1
          }))
        })
    },
    updateTime () {
      this.allTime = this.allTime - 1
      if (this.allTime === 0) {
        clearInterval(this.time)
        this.$confirm(`考试结束，确认交卷?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 交卷
          this.handExamHandle()
        }).catch(() => {
          this.$router.go(-1)
        })
      }
    },
    // 下一题
    next () {
      if (this.butLoading) {
        return false
      }
      this.butLoading = true
      let a = this.paperQuestionList.findIndex((item, index) => {
        return item.contentType === 1 && index > this.questionIndex
      })
      this.handQuestion(a, true, false)
    },
    // 上一题
    last () {
      if (this.butLoading) {
        return false
      }
      this.butLoading = true
      let list = [].concat(this.paperQuestionList)
      let a = list.reverse().findIndex((item, index) => {
        return item.contentType === 1 && index > (this.paperQuestionList.length - this.questionIndex - 1)
      })
      this.handQuestion(a !== -1 ? this.paperQuestionList.length - a - 1 : -1, false, false)
    },
    handQuestion (index, next = false, submit = false) {
      // next false 上一题， true下一题
      let question = this.paperQuestionList[this.questionIndex]
      if (question.subjectType === 1 && this.answer === '') {
        this.$message.error('请选择一项')
        this.butLoading = false
        return false
      } else if (question.subjectType === 2 && ((!this.answer) || (this.answer && this.answer.length < 2))) {
        this.$message.error('请至少选择两项')
        this.butLoading = false
        return false
      } else if (question.subjectType === 3 && this.answer === '') {
        this.$message.error('请输入内容')
        this.butLoading = false
        return false
      }
      if (question) {
        this.$http.post(`/front/train/trainEmUserAnswerRecord/save`, {
          'paperId': this.examId,
          'questionId': question.id,
          'paperUserId': this.paperUserId,
          'userAnswer': question.subjectType === 2 ? this.answer.join() : this.answer,
          'aliOssId': question.subjectType === 4 && this.fileList.length ? this.fileList[0].ossId : ''
        })
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (index > -1) {
                if (question.subjectType === 4) {
                  this.$refs.upLoadFile.clearFiles()
                }
                if (submit) {
                  this.submitHandle()
                } else {
                  this.getAnswer(index)
                }
              } else {
                if (next) {
                  this.$message.warning('已经是最后一道题了')
                  this.butLoading = false
                } else {
                  this.$message.warning('已经是第一道题了')
                  this.butLoading = false
                }
              }
            } else {
              if (submit) {
                this.submitHandle()
              } else {
                this.$message.error(res.message || '请重新点击')
                this.butLoading = false
              }
            }
          })
          .catch(() => {
            if (submit) {
              this.submitHandle()
            } else {
              this.butLoading = false
              this.$message.error('请重新点击')
            }
          })
      }
    },
    // 获取当前题目的答案
    getAnswer (index) {
      if (index !== this.questionIndex && index > -1) {
        this.questionIndex = index
        // 查找标题索引
        // this.headerIndex = this.questionIndex > 0 ? this.paperQuestionList[this.questionIndex - 1].contentType === 0 ? this.questionIndex - 1 : this.headerIndex : -1
        // this.headerIndex = this.paperQuestionList.slice(0, index).lastIndexOf(item => {
        //   return item.contentType === 0
        // })
        let question = this.paperQuestionList[this.questionIndex]
        this.answer = question.subjectType === 2 ? [] : ''
        this.fileList = []
        this.$http.post(`/front/train/trainEmUserAnswerRecord/selectAnswerResult`, {
          'paperId': this.examId,
          'questionId': question.id,
          'paperUserId': this.paperUserId
        })
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data !== null) {
                this.answer = question.subjectType === 2 ? res.data.userAnswer.split(',') : res.data.userAnswer
                // 类型4
                if (question.subjectType === 4 && res.data.aliOssId) {
                  this.fileList = [{
                    uid: res.data.aliOssId,
                    ossId: res.data.aliOssId,
                    ossName: res.data.aliOssId,
                    url: res.data.aliOssId
                  }]
                }
              } else {
                this.answer = question.subjectType === 2 ? [] : ''
              }
              this.butLoading = false
            } else {
              this.answer = question.subjectType === 2 ? [] : ''
              if (question.subjectType === 4 && res.data.aliOssId) {
                this.fileList = []
              }
              // this.$message.error(data.result.msg)
              this.butLoading = false
            }
          })
          .catch(() => {
            this.butLoading = false
          })
      } else {
        this.butLoading = false
      }
    },
    // 检测还有几道未达
    submitHandle () {
      if (this.allTime) {
        this.$http.get(`/front/train/trainEmUserAnswerRecord/selectSurplusSubject/${this.paperUserId}`)
          .then(({ data: res }) => {
            // console.log(data, '检测还有几道未达')
            if (res.code === 0) {
              this.handHandle()
            } else {
              this.$confirm(res.message || `考试结束，确认交卷?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                // 交卷
                this.handHandle()
              }).catch(() => {
                this.butLoading = false
              })
            }
          })
          .catch(() => {
            this.butLoading = false
          })
      } else {
        this.handHandle()
      }
    },
    // 交卷
    handHandle () {
      this.$http.post(`/front/train/trainEmUserAnswerRecord/saveExamResult`, {
        'paperId': this.examId
      })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success('交卷成功')
            if (this.time) {
              clearInterval(this.time)
            }
            this.$router.go(-1)
          } else {
            if (this.allTime === 0) {
              this.$router.go(-1)
            } else {
              this.$message.error(res.message || '交卷失败')
            }
          }
          this.butLoading = false
        })
        .catch(() => {
          this.butLoading = false
        })
    },
    // app刷新时间
    reloadExamTimeHandle () {
      let nowDate = new Date()
      let time = Math.floor((nowDate.getTime() - this.beginTime.getTime()) / 1000)
      this.allTime = time > 0 ? this.allTime - time : this.allTime
    },
    // 交卷
    handExamHandle () {
      if (this.butLoading) {
        return false
      }
      if (this.allTime) {
        // this.$http.get(`${window.SITE_CONFIG['trainURL']}/exam/trainemuseranswerrecord/selectSurplusSubject/${this.paperUserId}`)
        // .then(data => {
        //   if (data.result.code === 0) {
        //     this.butLoading = true
        //     this.handQuestion(this.questionIndex, false, true)
        //   } else {data.result.msg ||
        this.$confirm(`考试结束，确认交卷?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.butLoading = true
          // 交卷
          this.handQuestion(this.questionIndex, false, true)
        }).catch(() => {
          this.butLoading = false
        })
        //   }
        // })
      } else {
        this.butLoading = true
        this.submitHandle()
        // this.handQuestion(this.questionIndex, false, true)
      }
    },
    // 删除文件
    removeFile (file, fileList) {
      if (this.butLoading) {
        return false
      }
      if (file.ossId || file.response.result.data.id) {
        this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/${file.ossId || file.response.result.data.id}`)
          .then(item => {
            this.fileList = []
          })
          .catch(() => {
          })
      }
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.result.code === 0) {
        this.fileList.push({
          uid: file.uid,
          ossId: response.result.data.id,
          ossName: response.result.data.objectName,
          url: response.result.data.url
        })
        this.butLoading = false
      } else {
        file.onError()
        this.$message.error('上传失败')
        this.butLoading = false
      }
    },
    // 上传失败
    errorFile () {
      // err, file, fileList
      // this.$message
      this.butLoading = false
    },
    beforeUpload (file) {
      if (this.butLoading) {
        return false
      }
      this.butLoading = true
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        this.butLoading = false
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        this.butLoading = false
        return false
      }
    },
    download (entity) {
      if (entity && entity.objectName) {
        window.open(entity.objectName)
      }
    }
  },
  destroyed () {
    clearInterval(this.time)
  }
}
</script>
<style scoped>
@media screen and (max-width: 500px) {
  .exam {
    width: 100%;
    padding: 0.5em 0.2em;
  }
}
@media screen and (min-width: 501px) {
  .exam {
    width: 1190px;
    margin: 0 auto;
    padding: 40px 142px;
  }
}
.exam {
  background-color: #ffffff;
  /* font-size: 1em; */
}
.exam-name {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: 1.25em;
  color: #000;
  font-weight: bold;
}
.exam-score {
  text-align: left;
  font-weight: normal;
  font-size: 0.875em;
  color: #666666;
}
.exam-time {
  font-weight: normal;
  text-align: right;
  color: #1d65a8;
  font-size: 0.875em;
}
.test {
  margin: 1.8em 0;
}
.question {
  color: #333333;
  line-height: 1.4em;
}
.option li {
  /* margin-top: 2em; */
  /* line-height: 0.05rem;
    font-size: 0.05rem; */
}
.option-li {
  margin-top: 2em;
  line-height: 1.25em;
  /* display: table;
    margin-top: 1.8em;
    font-size: 0.875em;
    color: #333333; */
}
.answer-content {
  margin-top: 2em;
  width: 100%;
  padding: 0.2em;
  border-radius: 0.2em;
}
.answer-content:focus {
  border-color: #1d65a8;
}
.operation {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.button {
  height: 2.45em;
  padding: 0 2.45em;
  background: #1d65a8;
  border: none;
  color: #fff;
  cursor: pointer;
  user-select: none;
}
.shop-cart-but {
  background: #fff;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  margin: 0 0.625em;
}
.shop-cart-but:hover {
  background: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
}
.test-file {
  margin-top: 15px;
  line-height: 20px;
  cursor: pointer;
}
.test-file:hover {
  color: #1d65a8;
}
</style>
